import React, { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import Swal from 'sweetalert2'

import Dashboard from '@wrappers/Dashboard'
import { Title } from '@lib'
import ReleaseNoteForm from '@shared/ReleaseNoteForm'

const Content = ({ user }) => {
  const navigate = useNavigate()

  const handleSave = () => {
    navigate('/settings/notices-and-release-notes#release-notes')

    Swal.fire({
      text: 'Release note added!',
      icon: 'success',
      showConfirmButton: false,
      timer: 3000
    })
  }

  return (
    <Fragment>

      <Title text='New Release Note' user={user}/>

      <ReleaseNoteForm
        onSave={handleSave}
      />
    </Fragment>
  )
}

Content.propTypes = {
  user: PropTypes.object
}

const NewReleaseNote = () => {
  return (
    <Dashboard>
      <Content />
    </Dashboard>
  )
}

export default NewReleaseNote
